module.exports = __webpack_public_path__ + "static/media/IMG-19.b98e5f38.jpg";